import { ACADEMY_TRAINING_LIST, CLEAR_ACADEMY_TRAINING_LIST } from "../../constants"

const initialState = {
    trainingList: [],
    total: 0,
    totalPages: 0,
    currentPage: 0
}

export const getTrainingAcademyListReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACADEMY_TRAINING_LIST:
            const transformedData = action.payload.data.trainingList.map(item => ({
                id: item.parentId,
                title: item.name
            }));
            return {
                ...state,
                trainingList: [...state.trainingList, ...transformedData],
                total: action.payload.data.total,
                totalPages: action.payload.data.totalPages,
                currentPage: action.payload.data.currentPage,
            };

        case CLEAR_ACADEMY_TRAINING_LIST: {
            return {
                trainingList: [],
                total: 0,
                totalPages: 0,
                currentPage: 0
            }
        }
        default:
            return state;
    }


}